import { Navigate, useLocation, useParams } from 'react-router-dom';
import { ANALYZE_ROUTES, PROFILE_CAPTURE_ROUTES } from './routes.const';

function LegacyAppRoute() {
  const { module } = useParams();
  const { search } = useLocation();

  // Check for Profile Capture Route
  if (module === 'profile-capture') {
    return <Navigate to={`${PROFILE_CAPTURE_ROUTES.root}${search}`} replace={true} />;
  }

  return <Navigate to={`${ANALYZE_ROUTES.root}${search}`} replace={true} />;
}

export default LegacyAppRoute;
